import { createComponent } from '@lit/react';
import React from 'react';
import { SDSStepper } from '../sds-stepper/sds-stepper';
import { SheriffEventName } from './types';

export const SDSStepperWrapper = createComponent({
	tagName: 'sds-stepper',
	elementClass: SDSStepper,
	react: React,
	events: {
		onChange: 'change' as SheriffEventName,
	},
});
